import { Component, OnInit, Input, AfterViewInit, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CoreService, PortalService } from 'src/app/services';
import { OrderByPipe } from 'ngx-pipes';
import { Helpers } from 'src/app/helpers';
import _ from 'lodash';
import { IPortalConfig, PlatForm } from 'src/app/models';
import { fromEvent, startWith } from 'rxjs';
import { Constants } from 'src/app/shared/models/constants';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'medpt-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss'],
    providers: [OrderByPipe],
    standalone: false
})
export class NavigationMenuComponent implements OnInit, AfterViewInit {
  @Input() navigationMenu: any;
  @Input() Sponsor: any;
  @Input() Portal: any;
  menuItemCount: number = 0;
  showMore: boolean = false;
  private resizeCalling: boolean = false;
  cdnEndPoint = environment.cdnEndPoint;
  searchText = "";
  portalList: Array<IPortalConfig> = [];
  filteredPortalList: Array<IPortalConfig> = [];
  portalName!: string;
  studyMenuTitle: string = (Helpers.getPlatformId() == PlatForm.StudyStat ||Helpers.getPlatformId() == PlatForm.RaspberryAI) ? "Studies" :  "Portals";
  searchPlaceholderText: string = (Helpers.getPlatformId() == PlatForm.StudyStat  || Helpers.getPlatformId() == PlatForm.RaspberryAI)? "Search for Studies":"Search for Portals";
  myPortalsText: string = (Helpers.getPlatformId() == PlatForm.StudyStat ||Helpers.getPlatformId() == PlatForm.RaspberryAI) ? "My Studies" :  "My Portals";
  isStudyStat: boolean = (Helpers.getPlatformId() == PlatForm.StudyStat);
  isRaspberryAI: boolean = (Helpers.getPlatformId() == PlatForm.RaspberryAI);
  constructor(
    private coreService: CoreService,
    private portalService: PortalService
  ) {

  }

  ngOnInit(): void {

    this.menuItemCount = this.navigationMenu.length;
    
    let portalId = this.portalService.portalConfiguation.value.PortalID;
    this.portalName = <string>this.portalService.portalConfiguation.value.PortalName;
    //this.studyMenuTitle = this.platformId === PlatForm.TriPort ? 'Studies' : 'Portals';
    //this.searchPlaceholderText = this.platformId === PlatForm.TriPort ? 'Search for Studies' : 'Search for Portals';
    this.coreService.getUserPortals()
      .then((portals: Array<IPortalConfig>) => {
        //portals = _.filter(portals, { Portals: [{ PortalID: portalId }] });
        //this.portalList = this.filteredPortalList = portals.length > 0 ? (portals[0].Portals == null || portals[0].Portals == undefined) ? [] : portals[0].Portals : [];
        
        _.each(portals, (item: IPortalConfig, index: number) => {
          if (item.Portals == null && !portals[index].isClinical)
            this.portalList.push(portals[index])
          _.each(item.Portals, (childitem: IPortalConfig, childindex: number) => {                        
            this.portalList.push(childitem);
          });
        });        
        this.portalList = _.uniqBy(this.portalList, 'PortalID');
        this.portalList = _.orderBy(this.portalList, ['DisplayName'], ['asc']);
        this.filteredPortalList = this.portalList;        

      }).catch((error: any) => {

      }).finally(() => {

      });


  }

  over(drop: NgbDropdown) {
    if (!drop.isOpen())
      drop.toggle();
  }

  studiesDropOut($event: any, drop: NgbDropdown) {
    let isInsideControl = $($event.toElement).parents('li').hasClass('studyDrop');
    if (!isInsideControl)
      drop.close();
  }

  out($event: any, drop: NgbDropdown) {
    drop.close();
  }

  applyFilter($event: any) {
    this.filteredPortalList = this.portalList.filter((item: any) => {
      if (item.DisplayName.toString().toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    });
  }

  isCloudPortDocument(nav: any) {
    return nav.FeatureName == 'CloudPortDocuments';
  }
  isHomeLink(nav: any) {
    return nav.FeatureName == 'Home' && nav.ChildFeatures.length == 0;
  }
  isSafetyReports(nav: any) {
    return nav.FeatureName == 'SafetyReports';
  }
  isForms(nav: any) {
    return nav.FeatureName == 'Forms';
  }
  isMenu(nav: any) {
    return nav.FeatureName == 'Menu';
  }
  isStudyResource(nav: any) {
    return (nav.FeatureName == 'StudyResources' && Helpers.getPlatformId() == PlatForm.StudyStat);;
  }
  isStudyStatMetrics(nav: any) {
    return (nav.FeatureName == 'StudyMetrics' && Helpers.getPlatformId() == PlatForm.StudyStat);
  }
  isRaspberryAIFeature(nav: any) {
    return (nav.FeatureName == 'RASPberryAI' && Helpers.getPlatformId() == PlatForm.RaspberryAI);
  }
  isRAIMetrics(nav: any) {
    return (nav.FeatureName == 'RAIMetrics' && Helpers.getPlatformId() == PlatForm.RaspberryAI);
  }
  isRAIReviewerInbox(nav: any) {
    return (nav.FeatureName == 'ReviewerInbox' && Helpers.getPlatformId() == PlatForm.RaspberryAI);
  }
  canShowRootMenu(nav: any) {
    return (this.isCloudPortDocument(nav) && nav.ChildFeatures.length == 0) || this.isHomeLink(nav) || (!this.isCloudPortDocument(nav) && nav.ChildFeatures.length > 0 || this.isSafetyReports(nav) || this.isForms(nav) || this.isMenu(nav) || this.isStudyResource(nav) || this.isStudyStatMetrics(nav) || this.isRaspberryAIFeature(nav) || this.isRAIMetrics(nav) || this.isRAIReviewerInbox(nav) )
  }

  ngAfterViewInit() {
    fromEvent(window, 'resize').pipe(
      startWith(null)
    ).subscribe((item: any) => {
      /*console.log('navigationMenu resize', 'resizeCalling', this.resizeCalling);*/
      this.resetMenuItem();
    });
  }

  private resetMenuItem() {
    
    if (!this.resizeCalling && this.navigationMenu.length > 0) {
      this.resizeCalling = true;
      this.menuItemCount = this.navigationMenu.length;
      this.showMore = false;

      setTimeout(() => {
        var parentWidth = $('#nav-menu-main')[0].clientWidth;
        var navMenuMainElm = $('#nav-menu-main > li');
        if (navMenuMainElm.length > 0) {
          var visibleElementsCount: number = 0;
          var totalWidth = 0;
          
          navMenuMainElm.each((index, item) => {
            totalWidth = totalWidth + item.clientWidth + 25;
            if (parentWidth < totalWidth) {
              return;
            }
            visibleElementsCount += 1;
          });
          if (visibleElementsCount > 0) {
              this.menuItemCount = (visibleElementsCount == this.navigationMenu.length) ||
                            this.portalList.length >= 1 && (visibleElementsCount - 1) == this.navigationMenu.length
                            ? this.navigationMenu.length : (visibleElementsCount - 1) < this.navigationMenu.length ? visibleElementsCount - 2 : this.navigationMenu.length;
              this.showMore = this.menuItemCount != this.navigationMenu.length;   
              this.resizeCalling = false;
           }
        }
      }, 100);
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    const navigationMenuChange = changes['navigationMenu'];
    if (navigationMenuChange != undefined) {
      const currentNavigationMenu = navigationMenuChange.currentValue;
      this.navigationMenu = Array.isArray(currentNavigationMenu) ? currentNavigationMenu : [];

      if (this.navigationMenu.length > 0) {
          const raspberryAiMenu = this.navigationMenu.find((item:any) => item.FeatureName == 'RASPberryAI');
          if (raspberryAiMenu) {
            raspberryAiMenu.ChildFeatures = [];
          }
         if(Helpers.getPlatformId() == PlatForm.StudyStat){
            this.navigationMenu = _.filter(this.navigationMenu, (item) => { return item.FeatureName == 'Forms' || item.FeatureName == 'SafetyReports' || item.FeatureName == 'CloudPortDocuments' || item.FeatureName == 'Menu' || item.FeatureName == 'StudyResources' ||item.FeatureName == 'StudyMetrics' ||  item.ChildFeatures.length > 0;  });
         }else if(Helpers.getPlatformId() == PlatForm.RaspberryAI){
           this.navigationMenu = _.filter(this.navigationMenu, (item) => { return item.FeatureName == 'Forms' || item.FeatureName == 'SafetyReports' || item.FeatureName == 'CloudPortDocuments' || item.FeatureName == 'Menu' || item.FeatureName == 'RASPberryAI' || item.FeatureName == 'RAIMetrics' || item.FeatureName == 'ReviewerInbox' ||  item.ChildFeatures.length > 0;  });
         }else{
            this.navigationMenu = _.filter(this.navigationMenu, (item) => { return item.FeatureName == 'Forms' || item.FeatureName == 'SafetyReports' || item.FeatureName == 'CloudPortDocuments' || item.FeatureName == 'Menu' || item.ChildFeatures.length > 0;  });
         }        
        this.resetMenuItem();
      } 
    }
  }
}
